export default __webpack_public_path__ + "static/media/timeline.22df255d.png";